/**
 * Смуга «ТЕСТ» угорі екрана.
 *
 * Тестове середовище — точна копія бойового, аж до даних: ті самі люди, ті
 * самі замовлення, ті самі суми. Без видимої мітки в ньому працюватимуть як
 * у живому, а потім дивуватимуться, чому внесене нікуди не поділось.
 *
 * На бойовому інстансі `env_label` порожній — компонент не малює нічого.
 */
import { useAuthStore } from "@/store/auth";

export function EnvBanner() {
  const label = useAuthStore((s) => s.envLabel);
  if (!label) return null;

  return (
    <div
      role="status"
      className="fixed top-0 left-0 right-0 z-[9999] h-6 flex items-center justify-center
                 bg-amber-500 text-black text-[11px] font-black tracking-wide
                 pointer-events-none select-none"
    >
      {label} · дані тут несправжні, зміни на роботу цеху не впливають
    </div>
  );
}
